import React from "react";
import s from "./short-analytic-item.module.scss";
import { ReactComponent as TimeReloadIcon } from "assets/icons/time-reload.svg";
import { ReactComponent as CalendarDateIcon } from "assets/icons/calendar_date.svg";

import { useNavigate } from "react-router-dom";
import moment from "moment";

const ShortAnalyticItem = (props) => {

    const getFormatDate = (date) => {
        return moment(date).format("DD.MM.YYYY, HH:mm")
    }

    const navigate = useNavigate();

    const linkToPage = () => {
        //props.setTreeSelectedUUId(props.topicId);
        props.setSelectedSubtopicsAll([{name: props.topicName, id: props.topicId}], []);
        navigate('/page/main', { replace: true })
    }

    return (
        <div className={s.AnalyticItem}>
            <div className={s.topicTop}>
                <span onClick={linkToPage} className={s.topicName}>{props.topicName}</span>
            </div>
            <div className={s.topicBottom}>
                <div className={s.TopicDates}>
                    <div><TimeReloadIcon /><span>{getFormatDate(props.createdAt)}</span></div>
                    {/*<div><OpenEyeIcon /><span>{props.updatedAt}</span></div>*/}
                    <div><CalendarDateIcon /><span>{getFormatDate(props.updatedAt)}</span></div>
                </div>
                <div className={s.NewMessages}>
                    {/*<span className={s.NewMessagaesCount}>16</span>
                    <span className={s.NewMessagaesText}>{props.getValue('NEW_MESSAGES')}</span>*/}
                </div>
            </div>
        </div>
    )
}

export default ShortAnalyticItem;